// src/livekitSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as liveKitAPI from '../../api/livekit';

// Define an async thunk for fetching livekit
export const fetchToken = createAsyncThunk('livekit/fetchToken', async (_, { rejectWithValue, signal }) => {
    try {
        const response = await liveKitAPI.getToken(_, { signal }); // replace with your API URL
        if (response.token) {
            return response.token;
        }
        return null;
    } catch (error) {
        // Log the error (optional)
        console.error('Error fetching token:', error);
        // Return a specific error message
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

const initialState = {
    token: null,
    status: false,
    loading: false,
    error: null,
    messages: [],
    activeInstructor: null,

}
// Create the slice
const livekitSlice = createSlice({
    name: 'livekit',
    initialState: initialState,
    reducers: {
        resetState: () => { return initialState },
        play: (state) => { state.status = true },
        pause: (state) => { state.status = false },
        setActiveInstructor: (state, action) => {
            state.activeInstructor = action.payload;
        },
        addMessage(state, action) {
            state.messages.push(action.payload);
        },
        changeTutor: (state, action) => {
            state.messages = [];
            state.status = false;
            // state.token = null;
            state.activeInstructor = action.payload;
        },
        clearMessages(state) {
            state.messages = [];
        },
        removeMessage(state, action) {
            const id = action.payload; // Get the ID to remove
            state.messages = state.messages.filter(message => message.id !== id); // Filter out the message with the given ID
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchToken.pending, (state) => {
                state.loading = true;
                // state.status = false;

            })
            .addCase(fetchToken.fulfilled, (state, action) => {
                state.loading = false;
                state.token = action.payload;
                state.error = null;
                // state.status = false;

            })
            .addCase(fetchToken.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

// Export the async thunk and the reducer
export default livekitSlice.reducer;
const { changeTutor, setActiveInstructor, resetState, clearMessages, removeMessage, addMessage, play, pause } = livekitSlice.actions;
export { changeTutor, setActiveInstructor, resetState, clearMessages, removeMessage, addMessage, play, pause };